import { render, staticRenderFns } from "./correlate.vue?vue&type=template&id=5a7ef81b&"
import script from "./correlate.vue?vue&type=script&lang=js&"
export * from "./correlate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports